import { MouseEvent, useCallback } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

interface IDescriptionPresenter {
  handleCopyToClipboard(event: MouseEvent): void;
  copyToClipboard(): void;
}

export const useDescriptionPresenter = (description: string): IDescriptionPresenter => {
  const { t } = useTranslation();

  const copyToClipboard = useCopyToClipboard(description, t('chat_description_coppied'));

  const handleCopyToClipboard = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const nodeNames = ['BUTTON', 'A'];

      if (!nodeNames.includes((event.target as HTMLElement).nodeName)) {
        copyToClipboard();
      }
    },
    [copyToClipboard]
  );

  return {
    handleCopyToClipboard,
    copyToClipboard,
  };
};
